var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.signOut}},[_c('span',{staticClass:"fa fa-sign-out fa-2x"}),_c('p',[_vm._v("sign out")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a35c4c4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/home/_components/navigation-bar/_components/sign-out/sign-out.html
// module id = null
// module chunks = 